import script from "./OrderSeries.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderSeries.vue?vue&type=script&setup=true&lang=js"

import "./OrderSeries.vue?vue&type=style&index=0&id=dc1e00c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc1e00c6"]])

export default __exports__